<template>
  <div>
    <Errors :errors="errors" />

    <fieldset class="form-fieldset">
      <legend class="form-legend intake__heading mb-2">
        Persoonlijke gegevens
      </legend>

      <div class="bg-white p-2">
        <div class="form-group" id="salutation-wrapper">
          <label class="d-block" for="salutation">
            Aanhef
            <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
          </label>

          <input
            type="radio"
            id="salutation-mr"
            value="mr"
            name="salutation"
            required
            :checked="client.salutation === 'mr'"
            @change="(e) => updateClientField(['salutation', e.target.value])"
          />
          <label for="salutation-mr" class="mb-0 mr-3">Dhr.</label>

          <input
            type="radio"
            id="salutation-ms"
            value="ms"
            name="salutation"
            required
            :checked="client.salutation === 'ms'"
            @change="(e) => updateClientField(['salutation', e.target.value])"
          />
          <label for="salutation-ms" class="mb-0">Mevr.</label>
        </div>

        <div class="row row--tight-gutters">
          <div class="col-md-6">
            <div class="form-group" id="first-name-wrapper">
              <label for="first_name">
                Voornaam
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="text"
                id="first_name"
                required
                :value="client.first_name"
                @input="(e) => updateClientField(['first_name', e.target.value])"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" id="last-name-wrapper">
              <label for="last_name">
                Achternaam
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="text"
                id="last_name"
                required
                :value="client.last_name"
                @input="(e) => updateClientField(['last_name', e.target.value])"
              />
            </div>
          </div>
        </div>

        <div class="form-group" id="organization-wrapper">
          <label for="organization">
            Organisatie
          </label>

          <input
            class="form-control"
            type="text"
            id="organization"
            :value="client.organization"
            @input="(e) => updateClientField(['organization', e.target.value])"
          />
        </div>

        <div class="row row--tight-gutters">
          <div class="col-md-6">
            <div class="form-group mb-md-0" id="email-wrapper">
              <label for="email">
                E-mailadres
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="email"
                id="email"
                required
                :value="client.email"
                @input="(e) => updateClientField(['email', e.target.value])"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-md-0" id="phone-number-wrapper">
              <label for="phone_number">
                Telefoonnummer
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="tel"
                id="phone_number"
                required
                :value="client.phone_number"
                @input="(e) => updateClientField(['phone_number', e.target.value])"
              />
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset class="form-fieldset mt-3">
      <legend class="form-legend intake__heading mb-2">
        Adresgegevens
      </legend>

      <div class="bg-white p-2">
        <div class="row row--tight-gutters">
          <div class="col-md-6">
            <div class="form-group" id="street-wrapper">
              <label for="street">
                Straat
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="text"
                id="street"
                required
                :value="client.street"
                @input="(e) => updateClientField(['street', e.target.value])"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" id="house-number-wrapper">
              <label for="house_number">
                Huisnummer
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="text"
                id="house_number"
                required
                :value="client.house_number"
                @input="(e) => updateClientField(['house_number', e.target.value])"
              />
            </div>
          </div>
        </div>

        <div class="row row--tight-gutters">
          <div class="col-md-6">
            <div class="form-group" id="postal-code-wrapper">
              <label for="postal_code">
                Postcode
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="text"
                id="postal_code"
                required
                :value="client.postal_code"
                @input="(e) => updateClientField(['postal_code', e.target.value])"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" id="city-wrapper">
              <label for="city">
                Plaats
                <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
              </label>

              <input
                class="form-control"
                type="text"
                id="city"
                required
                :value="client.city"
                @input="(e) => updateClientField(['city', e.target.value])"
              />
            </div>
          </div>
        </div>

        <div class="form-group mb-md-0" id="country-wrapper">
          <label for="country">
            Land
            <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
          </label>

          <div class="custom-select">
            <select
              id="country"
              required
              :value="client.country"
              @change="(e) => updateClientField(['country', e.target.value])"
            >
              <option value="nl">Nederland</option>
              <option value="be">België</option>
              <option value="de">Duitsland</option>
            </select>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset class="form-fieldset mt-3">
      <legend class="form-legend intake__heading mb-2">
        Wensen
      </legend>

      <div class="bg-white p-2">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group" id="move-date-wrapper">
              <label for="move_date">
                {{ currentSite === 'inboedelopslag' ? 'Ingangsdatum reservering' : 'Gewenste verhuisdatum' }}
              </label>

              <input
                class="form-control"
                type="text"
                id="move_date"
                :value="project.move_date"
                @input="(e) => updateProjectField(['move_date', e.target.value])"
              />
            </div>
          </div>
        </div>

        <div v-if="currentSite !== 'inboedelopslag'">
          <div class="form-group" id="should-pack-wrapper">
            <label class="d-block" for="should-pack-yes">
              Inpakken van de verhuisdozen door Van Beek?
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              type="radio"
              id="should-pack-yes"
              :value="1"
              name="should_pack"
              required
              :checked="project.should_pack == 1"
              @change="(e) => updateProjectField(['should_pack', e.target.value])"
            />
            <label for="should-pack-yes" class="mb-0 mr-3">Ja</label>

            <input
              type="radio"
              id="should-pack-no"
              :value="0"
              name="should_pack"
              required
              :checked="project.should_pack == 0"
              @change="(e) => updateProjectField(['should_pack', e.target.value])"
            />
            <label for="should-pack-no" class="mb-0">Nee</label>
          </div>

          <div class="form-group" id="should-unpack-wrapper">
            <label class="d-block" for="should-unpack-yes">
              Uitpakken van de verhuisdozen door Van Beek?
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              type="radio"
              id="should-unpack-yes"
              :value="1"
              name="should_unpack"
              required
              :checked="project.should_unpack == 1"
              @change="(e) => updateProjectField(['should_unpack', e.target.value])"
            />
            <label for="should-unpack-yes" class="mb-0 mr-3">Ja</label>

            <input
              type="radio"
              id="should-unpack-no"
              :value="0"
              name="should_unpack"
              required
              :checked="project.should_unpack == 0"
              @change="(e) => updateProjectField(['should_unpack', e.target.value])"
            />
            <label for="should-unpack-no" class="mb-0">Nee</label>
          </div>

          <div class="form-group" id="should-assemble-wrapper">
            <label class="d-block" for="should-assemble-yes">
              Montage van meubelstukken door Van Beek?
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              type="radio"
              id="should-assemble-yes"
              :value="1"
              name="should_assemble"
              required
              :checked="project.should_assemble == 1"
              @change="(e) => updateProjectField(['should_assemble', e.target.value])"
            />
            <label for="should-assemble-yes" class="mb-0 mr-3">Ja</label>

            <input
              type="radio"
              id="should-assemble-no"
              :value="0"
              name="should_assemble"
              required
              :checked="project.should_assemble == 0"
              @change="(e) => updateProjectField(['should_assemble', e.target.value])"
            />
            <label for="should-assemble-no" class="mb-0">Nee</label>
          </div>

          <div class="form-group" id="use-storage-wrapper">
            <label class="d-block" for="use-storage-yes">
              Verhuizing via opslag? (Van Beek Inboedelopslag)
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              type="radio"
              id="use-storage-yes"
              :value="1"
              name="use_storage"
              required
              :checked="project.use_storage == 1"
              @change="(e) => updateProjectField(['use_storage', e.target.value])"
            />
            <label for="use-storage-yes" class="mb-0 mr-3">Ja</label>

            <input
              type="radio"
              id="use-storage-no"
              :value="0"
              name="use_storage"
              required
              :checked="project.use_storage == 0"
              @change="(e) => updateProjectField(['use_storage', e.target.value])"
            />
            <label for="use-storage-no" class="mb-0">Nee</label>
          </div>

          <div class="form-group mb-md-0" id="big-only-wrapper">
            <label class="d-block" for="big-only-yes">
              Verhuizen van alleen de grote stukken?
              <abbr class="no-abbr-style text-muted" title="Verplicht">*</abbr>
            </label>

            <input
              type="radio"
              id="big-only-yes"
              :value="1"
              name="big_only"
              required
              :checked="project.big_only == 1"
              @change="(e) => updateProjectField(['big_only', e.target.value])"
            />
            <label for="big-only-yes" class="mb-0 mr-3">Ja</label>

            <input
              type="radio"
              id="big-only-no"
              :value="0"
              name="big_only"
              required
              :checked="project.big_only == 0"
              @change="(e) => updateProjectField(['big_only', e.target.value])"
            />
            <label for="big-only-no" class="mb-0">Nee</label>
          </div>
        </div>
      </div>
    </fieldset>

    <button
      type="button"
      class="btn btn--primary mt-3"
      @click="() => setActiveTab(currentSite === 'inboedelopslag' ? 'addition': 'address')"
    >
      Volgende stap
    </button>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Errors from '@/intake/components/Errors.vue';

export default {
  components: {
    Errors,
  },

  computed: {
    ...mapGetters({
      currentSite: 'currentSite',
      client: 'client/client',
      project: 'client/project',
      errors: 'clientErrors',
    }),
  },

  methods: {
    ...mapMutations({
      setActiveTab: 'setActiveTab',
      updateClientField: 'client/updateClientField',
      updateProjectField: 'client/updateProjectField',
    }),
  },
};
</script>
